import { useTranslation } from "react-i18next";

const ServicesSection = () => {
  const { t } = useTranslation();
  const items = [0, 1, 2, 3, 4];

  return (
    <section id="uslugi" className="w-full bg-white py-16 px-6 md:px-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="text-center text-red-900 text-[30px] md:text-[36px] font-normal font-['Forum'] uppercase leading-[36px] md:leading-[75px] mb-16">
          {t("servicesSection.title")}
        </h2>

        <div className="flex flex-col">
          <div className="w-full h-px bg-red-900" />
          {items.map((index) => (
            <div key={index} className="flex flex-col">
              <div className="flex flex-col lg:flex-row gap-4 md:gap-12 py-8 w-full">
                <div className="w-full lg:w-[468px] flex-shrink-0">
                  <h3 className="text-red-900 text-[20px] font-semibold font-['Inter'] leading-[20px]">
                    {t(`servicesSection.items.${index}.title`)}
                  </h3>
                </div>
                <div className="w-full lg:flex-1 lg:max-w-[600px]">
                  <p className="text-red-900 text-[14px] font-light font-['Inter'] leading-[20px]">
                    {t(`servicesSection.items.${index}.description`)}
                  </p>
                </div>
              </div>
              {index < items.length - 1 && (
                <div className="w-full h-px bg-red-900" />
              )}
            </div>
          ))}
          <div className="w-full h-px bg-red-900" />
        </div>
      </div>
    </section>

  );
};

export default ServicesSection;

